// src/components/Admin/StudentHomeCmp/StudenthomeGrid.jsx

import React, { useState, useEffect } from "react";
import {
  InfoStudent,
  RutsPanelStudent,
  SalaActive,
  AssistantStudent,
  InfoSalaCmp,
  ScenesPanel,
  KahootQuizModal,
} from "./StudenthomePortalCmp";
import { TeacherAPI } from "../../../api/teacherAPI";
import { QuizApi } from "../../../api/quiz";
import {
  Button,
  Modal,
  Table,
  Loader,
  Message,
  Icon,
  Header,
} from "semantic-ui-react";
import "./StudenthomeGrid.scss";

const teacherApi = new TeacherAPI();
const quizApi = new QuizApi();
//evaluation
export function StudenthomeGrid({
  student,
  accessToken,
  classnumber,
  institutionID,
}) {
  // → Estados de selección
  const [selected, setSelected] = useState({
    routeId: null,
    classnumber: null,
    teacherId: null,
  });
  const [activeQuiz, setActiveQuiz] = useState(null);
  const [showQuizModal, setShowQuizModal] = useState(false);

  // → Estados para gestionar resultados
  const [studentResult, setStudentResult] = useState(null);
  const [loadingResult, setLoadingResult] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);

  // → Fondo dinámico de la fila 2
  const [row2Bg, setRow2Bg] = useState(null);

  // 1️⃣ Al cambiar teacherId, obtenemos el quiz activo completo
  useEffect(() => {
    if (!selected.teacherId) {
      setActiveQuiz(null);
      return;
    }
    (async () => {
      try {
        const { teacher } = await teacherApi.getTeacherById(
          accessToken,
          selected.teacherId
        );
        const quizId = teacher.quizActive;
        if (quizId) {
          const { quiz } = await quizApi.getQuizById(accessToken, quizId);
          setActiveQuiz({
            teacherQuizId: quizId,
            name: quiz.name,
            questions: quiz.questions,
            totalTime: quiz.totalTime,
          });
        } else {
          setActiveQuiz(null);
        }
      } catch (err) {
        console.error("Error cargando quiz activo:", err);
        setActiveQuiz(null);
      }
    })();
  }, [accessToken, selected.teacherId]);

  // 2️⃣ Al montar o cambiar activeQuiz, comprobamos si el alumno ya hizo el test
  useEffect(() => {
    async function fetchResult() {
      if (!student?._id || !activeQuiz) {
        setStudentResult(null);
        return;
      }
      setLoadingResult(true);
      try {
        // Ajusta el destructuring según tu API (p.ej. result.data, result.studentResult, etc.)
        const result = await quizApi.getDetailedStudentResult(
          accessToken,
          student._id,
          activeQuiz.teacherQuizId
        );
        // Suponemos que result.studentResult es el array de respuestas
        setStudentResult(result.studentResult || []);
      } catch (err) {
        // Si no existe, dejamos en null para permitir reintento
        setStudentResult(null);
      } finally {
        setLoadingResult(false);
      }
    }
    fetchResult();
  }, [accessToken, student, activeQuiz]);

  // 3️⃣ Al seleccionar ruta guardamos datos
  const handleSelectRoute = ({ routeId, classnumber, teacherId }) => {
    setSelected({ routeId, classnumber, teacherId });
    setRow2Bg(null);
  };


  return (
    <div className="student-home-grid">
      {/* === FILA 1: Info y Rutas === */}
      <div className="row">
        <div className="col col-left">
          <InfoStudent accessToken={accessToken} student={student} />
        </div>
        <div className="col col-middle">
          {/* === SIN RUTA SELECCIONADA === */}
          {!selected.routeId ? (
            <div className="intro-sections">
            <div className="intro-section rutas-creadas">
              <h2 className="intro-title">
                ¡Hola {student.name}! Aquí tienes las actividades que se han ido activando para ti.
              </h2>
              <p className="intro-description">
                Puede que tengas ayuda de algún asistente que se te haya asignado para tus tareas, <br />
                y también puede que debas hacer una evaluación al terminar de visitar las escenas activadas. <br />
                ¡Presta atención, y disfruta!
              </p>
              <hr className="intro-divider" />
            </div>
          </div>
          ) : (
            <>
              {/* === FILA 2: Sala, Asistentes, Info === */}
              <div>
                <div className="row row1">
                  <SalaActive
                    routeId={selected.routeId}
                    accessToken={accessToken}
                    onSceneBanner={setRow2Bg}
                  />
                  <InfoSalaCmp
                    routeId={selected.routeId}
                    accessToken={accessToken}
                  />
                  {/* === BOTÓN TEST / RESULTADO === */}
                  {activeQuiz && (
                    <div className="quiz-launcher">
                      {loadingResult ? (
                        <Loader inline size="small" />
                      ) : Array.isArray(studentResult) &&
                        studentResult.length > 0 ? (
                        <Button
                          color="teal"
                          onClick={() => setShowResultModal(true)}
                        >
                          <Icon name="chart bar outline" /> Ver Resultado
                        </Button>
                      ) : (
                        <Button
                          color="orange"
                          onClick={() => setShowQuizModal(true)}
                        >
                          <Icon name="question circle outline" /> Evaluación Escena
                        </Button>
                      )}
                    </div>
                  )}
                </div>
                <div className="row row2">
                  <AssistantStudent
                    routeId={selected.routeId}
                    accessToken={accessToken}
                  />
                </div>
                <div className="row row3">
                  <ScenesPanel
                    routeId={selected.routeId}
                    classnumber={selected.classnumber}
                    accessToken={accessToken}
                  />
                </div>
              </div>

              {/* === MODAL KAHOOT === */}
              {activeQuiz && (
                <KahootQuizModal
                  open={showQuizModal}
                  onClose={() => setShowQuizModal(false)}
                  quiz={activeQuiz}
                  accessToken={accessToken}
                  studentId={student._id}
                  onFinish={() => {
                    // tras completar, recargamos el resultado
                    setShowQuizModal(false);
                  }}
                />
              )}
            </>
          )}
        </div>
        <div className="col col-right">
          <RutsPanelStudent
            accessToken={accessToken}
            institutionId={institutionID}
            classNumber={classnumber}
            onSelectRoute={handleSelectRoute}
          />
        </div>
      </div>

      {/* === MODAL RESULTADO === */}
      <Modal
        open={showResultModal}
        onClose={() => setShowResultModal(false)}
        size="small"
        closeIcon
      >
        <Header icon="chart bar outline" content="Tu Resultado del Test" />
        <Modal.Content>
          {loadingResult ? (
            <Loader active inline="centered" />
          ) : studentResult && studentResult.length ? (
            <Table celled striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Pregunta</Table.HeaderCell>
                  <Table.HeaderCell>Seleccionada</Table.HeaderCell>
                  <Table.HeaderCell>Correcta</Table.HeaderCell>
                  <Table.HeaderCell>Tiempo (s)</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {studentResult.map((r, i) => (
                  <Table.Row key={i} positive={r.correct} negative={!r.correct}>
                    <Table.Cell>{r.questionIndex + 1}</Table.Cell>
                    <Table.Cell>{r.selected ?? "Sin respuesta"}</Table.Cell>
                    <Table.Cell>{r.correctAnswer}</Table.Cell>
                    <Table.Cell>{r.timeTaken}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          ) : (
            <Message info>
              <Message.Header>No se encontraron resultados</Message.Header>
            </Message>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={() => setShowResultModal(false)}>
            <Icon name="check" /> Cerrar
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
}
